import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import ErasmusQuestionnaire from '../ErasmusQuestionnaire';
import { useGetErasmusQuestionnaireByMobilityIdQuery } from '../../../../../../../redux/services/erasmusQuestionnaire';
import { Spinner } from '../../../../../../common/index';

const QuestionnaireModal = ({ visible, toggleModal, title, id, isLoading }) => {
  const { t } = useTranslation();
  const { data, isFetching } = useGetErasmusQuestionnaireByMobilityIdQuery(id);

  return (
    <Modal
      open={visible}
      title={title || t('Detail dotazníka')}
      onCancel={toggleModal}
      footer={null}
      width={1000}
    >
      {isLoading || isFetching ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Spinner />
        </div>
      ) : !data?.questionnaire?.id ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          {t('Dotazník nebol nájdený')}.
        </div>
      ) : (
        <ErasmusQuestionnaire mode={'preview'} id={data?.questionnaire?.id} />
      )}
    </Modal>
  );
};

QuestionnaireModal.propTypes = {
  visible: PropTypes.bool,
  toggleModal: PropTypes.func,
  title: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isLoading: PropTypes.bool,
};

export default QuestionnaireModal;
